module.exports = __webpack_public_path__ + "img/mytask_1.e2b6c5b3.jpg";